import { fetcher } from 'services/helpers/responseHandler'

const google = async ({ GoogleIdToken, geoLocation = {} }) =>
  await fetcher.post(`login/login-google`, { GoogleIdToken, geoLocation })

const microsoft = async ({ MicrosoftIdToken, geoLocation = {} }) =>
  await fetcher.post(`login/login-microsoft`, { MicrosoftIdToken, geoLocation })

const socialLoginApi = {
  google,
  microsoft
}

export default socialLoginApi
